import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api";
export const SITE_URL = "https://www.quotesbycity.com";
export const AFFILIATE_DEFAULT = "https://www.allstate.com/auto-insurance";

export const HERO_IMAGE = "https://images.pexels.com/photos/17177648/pexels-photo-17177648.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

export function setCanonical(path) {
  let link = document.getElementById("canonical-link");
  if (!link) {
    link = document.createElement("link");
    link.id = "canonical-link";
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = `${SITE_URL}${path}`;
}

export const STATE_NAMES_MAP = {
  AL:"Alabama",AK:"Alaska",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",CT:"Connecticut",DE:"Delaware",DC:"Washington DC",FL:"Florida",GA:"Georgia",HI:"Hawaii",ID:"Idaho",IL:"Illinois",IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",LA:"Louisiana",ME:"Maine",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",NH:"New Hampshire",NJ:"New Jersey",NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",OH:"Ohio",OK:"Oklahoma",OR:"Oregon",PA:"Pennsylvania",RI:"Rhode Island",SC:"South Carolina",SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",VA:"Virginia",WA:"Washington",WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming"
};
